import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade, Pagination } from "swiper/modules";

// Import Swiper styles needed
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

function initHomeCarousel() {
  const carouselElement = document.querySelector(".home-carousel");

  if (!carouselElement) {
    return;
  }

  const swiper = new Swiper(carouselElement, {
    modules: [Navigation, Autoplay, EffectFade, Pagination],
    loop: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".home-carousel-next",
      prevEl: ".home-carousel-prev",
    },
    pagination: {
      el: ".home-carousel-pagination",
      clickable: true,
    },
    on: {
      init: function () {
        const swiperInstance = this;
        let animationFrameId = null;

        // --- Animation Settings ---
        const easing = 0.08;

        const animateSprites = () => {
          const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
          const parallaxSprites = activeSlide.querySelectorAll(
            ".mouse-parallax-sprite"
          );

          parallaxSprites.forEach((sprite) => {
            // Initialize positions if they don't exist
            if (sprite._currentX === undefined) sprite._currentX = 0;
            if (sprite._currentY === undefined) sprite._currentY = 0;
            if (sprite._targetX === undefined) sprite._targetX = 0;
            if (sprite._targetY === undefined) sprite._targetY = 0;

            // Lerp formula for smooth animation
            sprite._currentX += (sprite._targetX - sprite._currentX) * easing;
            sprite._currentY += (sprite._targetY - sprite._currentY) * easing;

            // Apply the transform
            sprite.style.transform = `translate3d(${sprite._currentX}px, ${sprite._currentY}px, 0)`;
          });

          animationFrameId = requestAnimationFrame(animateSprites);
        };

        swiperInstance.el.addEventListener("mousemove", (e) => {
          const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
          const parallaxSprites = activeSlide.querySelectorAll(
            ".mouse-parallax-sprite"
          );
          if (!parallaxSprites.length) return;

          const { clientX, clientY } = e;
          const { left, top, width, height } =
            swiperInstance.el.getBoundingClientRect();
          const x = (clientX - left - width / 2) / (width / 2);
          const y = (clientY - top - height / 2) / (height / 2);

          parallaxSprites.forEach((sprite) => {
            const speed = parseFloat(sprite.dataset.mouseParallaxSpeed) || 0;
            sprite._targetX = x * speed * 100;
            sprite._targetY = y * speed * 100;
          });
        });

        // --- REMOVED mouseenter listener that was previously starting the animation ---

        swiperInstance.el.addEventListener("mouseleave", () => {
          const allSprites = swiperInstance.el.querySelectorAll(
            ".mouse-parallax-sprite"
          );
          allSprites.forEach((sprite) => {
            sprite._targetX = 0;
            sprite._targetY = 0;
          });
        });

        // --- ADDED: Start the animation loop immediately on init ---
        animateSprites();
      },
    },
  });
}

// Run the initialization
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initHomeCarousel();
} else {
  document.addEventListener("DOMContentLoaded", initHomeCarousel);
}
